import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

export const Wrapper = styled.div`
  width: 100%;
  /* Keep footer reachable on small screens */
  min-height: ${(props) => (props.$autoHeight ? "auto" : "320px")};
  height: ${(props) => (props.$autoHeight ? "auto" : "calc(100vh - 218px)")};
  /* Prefer dynamic viewport units when supported (fixes short viewport issues) */
  @supports (height: 100dvh) {
    height: ${(props) => (props.$autoHeight ? "auto" : "calc(100dvh - 218px)")};
  }
  overflow-y: auto;
  border-radius: 12px;
  border: none;
  display: inline-block;

  /* Custom Scrollbar Styles */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 4px;
  }
`;

export const useStyles = makeStyles((theme) => ({
  inActiveTree: {
    backgroundColor: "#fff",
  },
  cell: {
    outline: "none",
  },
}));
